module.exports = __webpack_public_path__ + "img/image12.39d3873b.png";